import PhoneInput from 'react-phone-input-2';
import styled from 'styled-components';

import 'react-phone-input-2/lib/style.css';

export const PhoneInputField = styled(PhoneInput)`
  .form-control {
    width: 100%;
    height: 2.5rem;
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.black_10};
    border-radius: ${({ theme }) => theme.spacing.zero_1};

    ::placeholder {
      color: ${({ theme }) => theme.colors.black};
    }

    background-color: ${({ theme }) => theme.colors.white};
    outline: none;

    :focus {
      border: 1px solid;
      border-color: ${({ theme }) => theme.colors.black};
    }
    :disabled {
      color: ${({ theme }) => theme.colors.black_40};

      background-color: ${({ theme }) => theme.colors.black_5};

      cursor: not-allowed;
    }
  }
`;
